// student-routing.module.ts

import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HospitalsComponent} from './hospitals/hospitals.component';
import {HospitalDetailComponent} from './hospital-detail/hospital-detail.component';
import {HospitalListComponent} from './hospital-list/hospital-list.component';
import {DoctorsComponent} from './doctors/doctors.component';
import {DoctorListComponent} from './doctor-list/doctor-list.component';
import {DoctorDetailComponent} from './doctor-detail/doctor-detail.component';
import {PharmaciesComponent} from './pharmacies/pharmacies.component';
import {PharmacyListComponent} from './pharmacy-list/pharmacy-list.component';
import {PharmacyDetailComponent} from './pharmacy-detail/pharmacy-detail.component';
import {LabsComponent} from './labs/labs.component';
import {LabListComponent} from './lab-list/lab-list.component';
import {LabDetailComponent} from './lab-detail/lab-detail.component';
import {HospitalDoctorDetailComponent} from './hospital-doctor-detail/hospital-doctor-detail.component';
import {LandingComponent} from "../landing/landing.component";


const routes: Routes = [
  {
    path: 'hospitals',
    component: HospitalsComponent,
    children: [
      {
        path: 'list',
        component: HospitalListComponent,
      },
      {
        path: 'detail/:id',
        component: HospitalDetailComponent,
      },
      {
        path: 'doctor-detail/:id',
        component: HospitalDoctorDetailComponent,
      }
    ]
  },
  {
    path: 'doctors',
    component: DoctorsComponent,
    children: [
      {
        path: 'list',
        component: DoctorListComponent,
      },
      {
        path: 'detail/:id',
        component: DoctorDetailComponent,
      }
    ]
  },
  {
    path: 'partner',
    component: LandingComponent,
  },
  {
    path: 'pharmacy',
    component: PharmaciesComponent,
    children: [
      {
        path: 'list',
        component: PharmacyListComponent,
      },
      {
        path: 'detail/:id',
        component: PharmacyDetailComponent,
      }
    ]
  },
  {
    path: 'labs',
    component: LabsComponent,
    children: [
      {
        path: 'list',
        component: LabListComponent,
      },
      {
        path: 'detail/:id',
        component: LabDetailComponent,
      }
    ]
  },
  {
    path: 'blood',
    component: PharmaciesComponent,
    children: [
      {
        path: 'list',
        component: PharmacyListComponent,
      },
      {
        path: 'detail/:id',
        component: PharmacyDetailComponent,
      }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartnerPagesRoutingModule {
}
